// extracted by mini-css-extract-plugin
export default {"container":"GrayWindow_container__T1u2P","background":"GrayWindow_background__lFw9u","main":"GrayWindow_main__GHscA"};